import ROUTE_PATH from '@constants/routes';
import useRentalPropertyDetail from '@hooks/RentalProperty';
import RPContent from '@pages/Explore/components/RPModal/components/RPContent';
import RPMediaCarousel from '@pages/Explore/components/RPModal/components/RPMediaCarousel';
import { Button, Col, Empty, Modal, Row, Space, Spin, Typography } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './style.less';

type RPModalProps = {
  rpId: string | null;
  open: boolean;
  onClose: () => void;
};

const RPModal: React.FC<RPModalProps> = ({ rpId, open, onClose }) => {
  const { t } = useTranslation('RentalProperty');
  const query = useMemo(() => [rpId], [rpId]);
  const { data, loading } = useRentalPropertyDetail(query);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      className="rp-detail-modal"
    >
      <Spin spinning={loading}>
        {data == null ? (
          <Empty />
        ) : (
          <Space direction="vertical" className="full-width">
            <Typography.Title level={2} className="text-center">
              {data?.name}
            </Typography.Title>
            <Row gutter={[20, 20]}>
              <Col xs={24} lg={8}>
                <RPMediaCarousel rpMedias={data.medias} />
              </Col>
              <Col xs={24} lg={16}>
                <RPContent data={data} />
              </Col>
            </Row>
            <Link to={ROUTE_PATH.BOOKING} state={{ rentalProperty: data }}>
              <Button type="primary" className="full-width">
                {t('Booking')}
              </Button>
            </Link>
          </Space>
        )}
      </Spin>
    </Modal>
  );
};

export default RPModal;
